/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-30 15:24:34
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-04 10:16:13
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\utils\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import accountManager from './account';
import applicationRoutes from '../config/routes/application';

/**
 * 根据 path 转 name
 * @param {string} path vue-router path
 * @returns vue-router name
 */
export function pathToName(path) {
  if (!path) {
    return '';
  }
  return path
    .replace(/:/g, '')
    .split('/')
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join('');
}

export function getLoginPath(loginType = '', route) {
  const type = loginType || accountManager.getLoginType();
  let loginPath =
    {
      4: '/homeLogin',
      6: '/homeLogin', //'/cuserLogin',
    }[type] || '/homeLogin';

  let redirect = '';
  if (route && route.path) {
    redirect = route.path;
    loginPath += `?redirect=${redirect}`;
  }
  return loginPath;
}

export function toLoginPage(loginType, router, route) {
  const loginPath = getLoginPath(loginType, route);
  router.push(loginPath);
}

export function getStaticRoutes(loginType = '') {
  const type = loginType || accountManager.getLoginType();
  const staticRoutes =
    {
      4: applicationRoutes,
      6: applicationRoutes, //[],
    }[type] || [];
  return staticRoutes;
}
